<template>
  <div>
    <el-card class="box-card" style="height: auto" shadow="never">
      <div slot="header" class="clearfix">
        <h2>项目管理</h2>
      </div>

      <el-form :model="searchForm" inline label-width="100px">
        <el-form-item label="项目名称：">
          <el-input style="width: 300px" v-model="searchForm.projectName" placeholder="请输入项目名称"></el-input>
        </el-form-item>

        <el-form-item label="类型：">
          <el-select v-model="searchForm.projectMeetingType" clearable>
            <el-option v-for="item in types" :key="item.value" :label="item.name"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>

      <!-- 表格 -->
      <el-table :data="pList" style="width: 100%; margin-top: 20px;" border stripe>
        <el-table-column prop="id" label="ID" width="80" align="center"></el-table-column>
        <el-table-column prop="projectName" label="项目名称" min-width="180"></el-table-column>
        <el-table-column prop="projectManager" label="项目负责人" width="120"></el-table-column>
        <el-table-column prop="clearingBuyerName" label="结算负责人" width="120"/>
        <el-table-column label="供应商" min-width="140">
          <template #default="scope">
            <div class="supplier-info">
              <div class="supplier-name">{{ scope.row.supplierName || '' }}</div>
              <div class="supplier-phone" v-if="scope.row.actuatorPhone">
                {{ scope.row.actuatorPhone }}
              </div>
              <!--              <div class="supplier-phone" v-else>—</div>-->
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="totalPrice" label="中标金额(元)" width="140"/>


        <el-table-column prop="status" label="起止时间" width="200">
          <template slot-scope="scope">
            {{
              (scope.row.projectStartDate ? $moment(scope.row.projectStartDate).format('L') : '-')
              + ' - ' +
              (scope.row.projectEndDate ? $moment(scope.row.projectEndDate).format('L') : '-')
            }}
          </template>
        </el-table-column>

        <el-table-column prop="status" label="类型" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.projectMeetingType == 'series' ? 'primary' : 'success'">
              {{ scope.row.projectMeetingType == 'series' ? '系列会' : '单场会' }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column
            fixed="right"
            label="操作"
            width="100">
          <template slot-scope="scope">
            <!--            <el-button   class="WAIT_CLAIM"  type="text"-->
            <!--                       @click.stop="claimMeeting(scope.row)">认领项目-->
            <!--            </el-button>-->

            <el-button class="details" type="text"
                       @click.stop="toMeetList(scope.row)">进入会议
            </el-button>

          </template>
        </el-table-column>
      </el-table>


      <el-pagination style="float: right;margin: 25px" background layout="prev, pager, next" :total="searchForm.total"
                     :page-size="searchForm.size"
                     :current-page="searchForm.page" class="pagination" @current-change="handlePage"
                     :hide-on-single-page="false"></el-pagination>


    </el-card>


  </div>
</template>

<script>
import {
  claimProject,
  getProjectStatusNum,
  officialTodayMeeting,
  ogetMeetingUrl,
  oprojectList,
  newOfficialProjectList
} from '@/request/api.js';

export default {
  name: 'projectlist',
  components: {},
  data() {
    return {
      searchForm: {
        total: 0,
        current: 1,
        size: 10,
      },
      curNow: "WAIT",
      pList: [],
      todayMeetList: [],

      types: [
        {
          name: '单场会',
          value: 'single',
        }, {
          name: '系列会',
          value: 'series',
        }],

      list: [{
        name: '进行中的项目',
        class: 'WAIT',
      }, {
        name: '待认领的项目',
        class: 'WAIT_CLAIM',
      }, {
        name: '已结束的项目',
        class: 'FINISH',
      }],
      message: ''
    }
  },
  created() {
    this.getProjectList();
  },


  methods: {
    // 认领会议
    claimMeeting(item) {
      // console.log(JSON.parse(JSON.stringify(item)))
      this.$alert('是否确认认领该项目？', '认领项目', {
        confirmButtonText: '确定',
        callback: action => {
          claimProject({
            projectId: item.id
          }).then(res => {
            if (res.code == 200) {
              this.getProjectList();
              this.$forceUpdate();
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      });
    },


    handlePage(page) {
      this.searchForm.current = page
      this.getProjectList()
    },


    handleSearch() {
      this.searchForm.current = 1
      this.getProjectList()
    },

    handleReset() {
      this.searchForm = {
        total: 0,
        current: 1,
        size: 10
      }
      this.getProjectList()
    },


    // 创建会议
    newMeeting(item) {
      localStorage.setItem('projectDetails', JSON.stringify(item))
      this.$router.push({
        name: 'createmeet',
        query: {
          pId: item.id
        }
      })
    },

    // 查看会议详情
    toMeetList(item) {
      localStorage.setItem('projectDetails', JSON.stringify(item))
      this.$router.push({
        name: 'officialMeetinglist',
        query: {
          pId: item.id
        }
      })
    },

    // 回款结算
    settleAnAccount(item) {
      localStorage.setItem('projectDetails', JSON.stringify(item))
      this.$router.push({
        name: 'settleaccount',
        query: {
          pId: item.id
        }
      })
    },

    // 进入会议
    enterTheMeeting(item) {
      // localStorage.setItem('projectDetails', JSON.stringify(item))
      let data = {
        meetingId: item.id
      }
      ogetMeetingUrl(data).then(res => {
        if (res.code == 200) {
          window.open(res.data)
        }
      })
    },


    // 获取项目列表
    getProjectList() {
      newOfficialProjectList(this.searchForm).then(res => {
        if (res.code == 200) {
          this.pList = res.data.records;
          this.searchForm.total = res.data.total;
        }
      })
    },

    // 分页切换
    getMyProject(e) {
      this.page = e;
      this.getProjectList();
    },

    // 切换会诊选项
    tabsChange(item) {
      this.page = 1;
      this.curNow = item.class;
      this.getProjectList();
      this.getProjectItemNums();
    },
  }
}
</script>

<style lang="scss" scoped>
.supplier-info {
  line-height: 1.4;
  text-align: left;
}

.supplier-name {
  font-weight: 500;
  color: #333;
}

.supplier-phone {
  font-size: 12px;
  color: #909399;
  margin-top: 2px;
}
</style>
